import {eYaca} from '../environments/environment.yaca';
import {eZidou} from '../environments/environment.zidou';

export interface Environment {
  app_name: string;
  app_name_real: string;
  base_url: string;
  base_url_c:string;
  env_url: string;
  domain: string;
  bot_name: string;
  app_name_string: string;
  menu_auth_pc: Array<string>;
  menu_auth_wx: Array<string>;
  app_id: string;
  token_name: string;
  logo_icon_url: string;
  logo_loader_icon: string;
  host_url: string;
  live_zidou: number;
  logo_path:string;
  shareDirection:string;
  topicFlag:string;
}

//一级菜单
interface MenuItem {
  id: string;
  title: string;
  icon?: string;
  router_link?: string;
  sub_items?: Array<MenuItem>;
  isSubItem?: boolean; //标志这个菜单是否是一个子菜单，和其他子菜单共享父菜单的路径，如敏感词和员工管理下的两个子菜单
  hide?:boolean;
}

//Pc大酒店分类菜单

const classifyMenuPc: Array<MenuItem> = [
  {
    id: 'robot',
    title: '小助手管理',
    icon: 'android',
    sub_items: [
      {
        id: 'assistant',
        title: '小助手列表',
        router_link: '/features/robot',
        isSubItem: true
      },
      {
        id: 'moments',
        title: '发朋友圈',
        router_link: '/features/moments',
        isSubItem: true
      },
      {
        id: 'friend-welcome',
        title: '新好友应答',
        router_link: '/features/friend-welcome',
        isSubItem: true
      }
    ]
  },
  {
    id: 'dataCenterMenu',
    title: '数据中心',
    icon: 'inbox',
    sub_items: [
      {
        id: 'statis',
        title: '数据分析',
        icon: 'area-chart',
        router_link: '/features/analysis/chatroom-list'
      },
      {
        id: 'share_task',
        title: '链接追踪',
        icon: 'link',
        router_link: '/features/share'
      },
      {
        id: 'analyse',
        title: '舆情分析',
        icon: 'share-alt',
        router_link: '/features/analyse',
      }
    ]
  },
  // {
  //   id: "welcome",
  //   icon: "smile-o",
  //   title: "入群欢迎语",
  //   router_link: "/features/welcome/home"
  // },
  {
    id: 'acquisitionMenu',
    title: '拉新',
    icon: 'user-add',
    sub_items: [
      {
        id: 'fisson',
        title: '老客拉新',
        icon: 'notification',
        router_link: '/features/chatroom-fisson',
      },
      {
        id: 'acquisition',
        title: '永久入群二维码',
        icon: 'qrcode',
        router_link: '/features/pull-new/home'
      },
      {
        id: 'welcome',
        icon: 'smile-o',
        title: '入群欢迎语',
        router_link: '/features/welcome/home'
      },
      {
        id: 'channel',
        icon: 'switcher',
        title: '渠道码',
        router_link: '/features/channel-qrcode/home'
      },
    ]
  },
  {
    id: 'keepActiveMenu',
    title: '促活',
    icon: 'rocket',
    sub_items: [
      {
        id: 'sign',
        title: '签到',
        icon: 'calendar',
        router_link: '/features/sign',
      },
      {
        id: 'ai_reply',
        title: '智能陪聊',
        icon: 'message',
        router_link: '/features/ai_replay'
      },
      {
        id: 'chatroom_score',
        title: '群积分',
        icon: 'calculator',
        router_link: '/features/chatroom-score',
      },
      {
        id: 'score_transaction',
        icon: 'credit-card',
        title: '积分交易',
        router_link: '/features/score-deal',
        hide:true,
      },
    ]
  },
  {
    id: 'basicUtilityMenu',
    title: '基础功能',
    icon: 'tool',
    sub_items: [
      {
        id: 'batch_sending',
        title: '群发',
        icon: 'fork',
        router_link: '/features/mass',
      },
      {
        id: 'announcement',
        title: '群公告',
        icon: 'schedule',
        router_link: '/features/group-announcement',
      },
      {
        id: 'auto_reply',
        title: '关键词回复',
        icon: 'notification',
        router_link: '/features/auto/auto-keyword'
      },
      {
        id: 'ad',
        title: '广告监测',
        icon: 'exception',
        router_link: '/features/advert'
      },
      {
        id: 'sensitive',
        title: '群消息监控',
        icon: 'bell',
        sub_items: [
          {
            id: 'sensitive-msg',
            title: '命中消息列表',
            router_link: '/features/sensitive/sensitive-msgs',
            isSubItem: true
          },
          {
            id: 'sensitive-list',
            title: '监控内容设置',
            router_link: '/features/sensitive/sensitive-list',
            isSubItem: true
          }
        ]
      },
      {
        id: 'blacklist',
        title: '黑名单',
        icon: 'user-delete',
        router_link: '/features/blacklist'
      },
    ]
  },
  {
    id: 'contentReserveMenu',
    title: '内容沉淀',
    icon: 'book',
    sub_items: [
      {
        id: 'group_zone',
        title: '群空间',
        icon: 'api',
        router_link: '/features/zone'
      },
      {
        id: 'essence',
        title: '群精华',
        icon: 'book',
        router_link: '/features/essence',
      }
    ]
  },
  {
    id: 'biquan',
    title: '币圈',
    icon: 'pay-circle-o',
    sub_items: [
      {
        id: 'coin',
        title: '实时报价',
        icon: 'line-chart',
        router_link: '/features/quotes'
      },
      {
        id: 'wallet',
        title: '钱包地址',
        icon: 'wallet',
        router_link: '/features/wallet'
      },
    ]
  },
  {
    id: 'employee',
    title: '业务员监控',
    icon: 'eye-o',
    router_link: '/features/support'
  },
  {
    id: 'staff',
    title: '团队协作',
    icon: 'team',
    sub_items: [
      {
        id: 'staff-list',
        title: '员工列表',
        router_link: '/features/staff/staff-list',
        isSubItem: true
      },
      {
        id: 'role-list',
        title: '角色列表',
        router_link: '/features/staff/role-list',
        isSubItem: true
      }
    ]
  },
  {
    id: 'level',
    title: '团队协作',
    icon: 'team',
    router_link: '/features/level',
  },
  // {
  //   id: 'assistant',
  //   title: '小助手管理',
  //   icon: 'android',
  //   router_link: '/features/robot'
  // },

  {
    id: 'remote',
    title: '远程登录',
    icon: 'share-alt',
    router_link: '/features/remote',
  },
  {
    id: 'live',
    title: '群直播',
    icon: 'play-circle',
    router_link: '/features/chatroom-live',
  },
  {
    id: 'pay',
    title: '紫豆钱包',
    icon: 'wallet',
    router_link: '/features/zidou-pay',
  },
  /*{
    id: 'essence',
    title: '群精华',
    icon: 'book',
    router_link: '/features/essence',
  }*/
];

//素材类型基本数据
const material_type = [
  {
    id: 'picture',
    label: '图片',
    real_type: 2,
    icon: 'picture',
    img: 'image'
  },
  {
    id: 'video',
    label: '视频',
    img: 'video',
    icon: 'video-camera',
    real_type: 3
  },
  {
    id: 'voice',
    label: '语音',
    real_type: 4,
    icon: 'notification',
    img: 'voice'
  },
  {
    id: 'link',
    label: '链接',
    real_type: 5,
    icon: 'link',
    img: 'link'
  },
  {
    id: 'file',
    label: '文件',
    real_type: 6,
    icon: 'file',
    img: 'file'
  },
  {
    id: 'program',
    label: '小程序',
    real_type: 7,
    icon: 'appstore-o',
    img: 'miniProgram'
  },
  {
    id: 'card',
    label: '公众号',
    real_type: 8,
    icon: 'solution',
    img: 'gongzhonghao'
  }

];

interface WxMenuItem {
  id: string;
  img: string;
  name: string;
  status?: string;
  is_old: boolean;
  page: string;
}

//微信大酒店总菜单
const menuAllWx: Array<WxMenuItem> = [
  {
    id: 'statis',
    img: 'analysis.png',
    name: '数据分析',
    status: '',
    is_old: true,
    page: 'ChatroomPage'
  },
  {
    id: 'essence',
    img: 'essence.png',
    name: '群精华',
    status: '',
    is_old: false,
    page: 'EssencePage',
  },
  {
    id: 'sign',
    img: 'sign.png',
    name: '签到',
    status: '',
    is_old: false,
    page: 'SignPage',
  },
  {
    id: 'analyse',
    img: 'analyse.png',
    name: '舆情分析',
    status: '',
    is_old: false,
    page: 'WordPage'
  },
  {
    id: 'ai_reply',
    img: 'ai_reply.png',
    name: '智能陪聊',
    status: '',
    is_old: false,
    page: 'AiReplayPage'
  },
  {
    id: 'acquisition',
    img: 'qrcode.png',
    name: '永久入群',
    status: '',
    is_old: true,
    page: 'PermanentQrHomePage'
  },
  {
    id: 'welcome',
    img: 'welcome.png',
    name: '入群欢迎语',
    status: '',
    is_old: false,
    page: 'WelcomeVer2HomePage'
  },
  {
    id: 'batch_sending',
    img: 'send.png',
    name: '群发',
    status: '',
    is_old: true,
    page: 'SendPage'
  },
  {
    id: 'ad',
    img: 'a_d1.png',
    name: '广告监测',
    status: '',
    is_old: true,
    page: 'SpeakSettingPage'
  },
  {
    id: 'auto_reply',
    img: 'auto.png',
    name: '关键词回复',
    status: 'func_reply',
    page: 'AutoPage',
    is_old: true
  },
  {
    id: 'blacklist',
    img: 'blacklist.png',
    name: '黑名单',
    status: 'func_backlist',
    page: 'BacklistPage',
    is_old: true
  },
  {
    id: 'sensitive',
    img: 'news.png',
    name: '群消息监控',
    status: '',
    page: 'SensitiveMsgPage',
    is_old: true
  },
  {
    id: 'group_zone',
    img: 'zone.png',
    name: '群空间',
    status: '',
    page: 'ZonePage',
    is_old: true
  },
  {
    id: 'share_task',
    img: 'share.png',
    name: '链接追踪',
    status: '',
    page: 'LinkPage',
    is_old: true
  },
  {
    id: 'coin',
    img: 'price.png',
    name: '实时报价',
    status: 'func_real_time_quotes',
    page: 'RealTimeQuotesPage',
    is_old: true
  },

  {
    id: 'wallet',
    img: 'wallet.png',
    name: '钱包地址',
    status: 'func_coin_wallet',
    page: 'WalletPage',
    is_old: true
  },
  {
    id: 'employee',
    img: 'saleman.png',
    name: '业务员监控',
    status: '',
    page: 'SupportMainPage',
    is_old: true
  },
  {
    id: 'assistant',
    img: 'robot.png',
    name: '小助手管理',
    status: '',
    page: 'RobotListPage',
    is_old: true
  },
  {
    id: 'staff',
    img: 'staff.png',
    name: '员工管理',
    status: '',
    page: 'EmployeePage',
    is_old: true
  },
  // {
  //   id: 'bibisheng',
  //   img: 'bibisheng.png',
  //   name: '领取币币升',
  //   is_old: true,
  //   status: '',
  //   page: ''
  // },
];

const menu_list = [
  {
    'menu_id': 'welcome',
    'menu_name': '入群欢迎语',
    'menu_desc': '欢迎语条数限制'
  },
  {
    'menu_id': 'sign',
    'menu_name': '签到',
    'menu_desc': '设置群签到，提高用户黏度'
  },
  // {
  //   "menu_id": "group-announcement",
  //   "menu_name": "群公告",
  //   "menu_desc": "设置群公告"
  // },
  {
    'menu_id': 'keyword',
    'menu_name': '关键词回复',
    'menu_desc': '关键词设置条数上限'
  },
  {
    'menu_id': 'statistics',
    'menu_name': '数据分析',
    'menu_desc': '统计群内成员活跃、拉新、退群情况'
  },
  {
    'menu_id': 'chatroom_manage',
    'menu_name': '群管理',
    'menu_desc': '社群安置'
  },
  {
    'menu_id': 'acquisition_reply',
    'menu_name': '邀请查询',
    'menu_desc': '群内查询邀请人数'
  },
  {
    'menu_id': 'batch',
    'menu_name': '群发',
    'menu_desc': '单日群发条数上限'
  },
  {
    'menu_id': 'sensitive',
    'menu_name': '群消息监控',
    'menu_desc': '群消息敏感词监测条数上限'
  },
  {
    'menu_id': 'blacklist',
    'menu_name': '黑名单',
    'menu_desc': '黑名单人数上限'
  },
  {
    'menu_id': 'robot',
    'menu_name': '小助手管理',
    'menu_desc': '查看所有机器人的覆盖群数和人数等'
  },
  {
    'menu_id': 'ai_reply',
    'menu_name': '智能陪聊',
    'menu_desc': 'AI问答，智能陪聊'
  },
  {
    'menu_id': 'share_task',
    'menu_name': '链接追踪',
    'menu_desc': '追踪发送链接的查看数和点击量'
  },
  {
    'menu_id': 'chatroom_zone',
    'menu_name': '群空间',
    'menu_desc': '存储群链接、图片、文件'
  },
  {
    'menu_id': 'acquisition',
    'menu_name': '拉新二维码',
    'menu_desc': '社群拉新，快速裂变'
  },
  {
    'menu_id': 'ad',
    'menu_name': '数据分析',
    'menu_desc': '监督群内发言并提醒管理者'
  },
  {
    'menu_id': 'wallet',
    'menu_name': '钱包地址',
    'menu_desc': '自动收集钱包地址'
  },
  {
    'menu_id': 'coin',
    'menu_name': '实时报价',
    'menu_desc': '可在群内查看数字货币实时报价'
  },
  {
    'menu_id': 'analyse',
    'menu_name': '舆情分析',
    'menu_desc': '为您监控社群舆论热点'
  }
  // {
  //   "menu_id": "essence",
  //   "menu_name":"群精华",
  //   "menu_desc": "筛选时间段内的目标群的群聊内容"
  // }
];

export class Global implements Environment {
  app_name: string;
  app_name_real: string;
  base_url: string;
  base_url_c:string;
  env_url: string;
  domain: string;
  bot_name: string;
  app_name_string: string;
  menu_auth_pc: Array<string>;
  menu_auth_wx: Array<string>;
  app_id: string;
  token_name: string;
  material_type: Array<any>;
  logo_icon_url: string;
  logo_loader_icon: string;
  unreadNotificationCount: number = 0;
  shareDirection:string;
  topicFlag:string;


  //pc 的最终menu
  menu_pc: Array<MenuItem>;
  //wx 的最终menu
  menu_wx: Array<WxMenuItem>;
  //
  host_url: string;
  live_zidou: number;
  logo_path:string;

  shangCengFlag: boolean;
  shangCengFlagSub: boolean;
  haveEmployee: boolean;

  //some const value
  nodataText = '暂时没有数据';
  errText = '出现了一些意料之外的错误';
  errBtnText = '重新尝试';

  phoneReg = /^(1)\d{10}$/;
  displayCommonMenu = [];
  lastUsedModuleId;
  classifyMenu = [
    {
      'name': '数据中心',
      'modules': ['statis', 'share_task', 'analyse']
    },
    {
      'name': '拉新',
      'modules': ['acquisition', 'welcome']
    },
    {
      'name': '促活',
      'modules': ['sign', 'ai_reply']
    },
    {
      'name': '基础功能',
      'modules': ['batch_sending', 'group-announcement', 'auto_reply', 'ad', 'sensitive', 'blacklist']
    },
    {
      'name': '内容沉淀',
      'modules': ['group_zone', 'essence']
    },
    {
      'name': '币圈',
      'modules': ['coin', 'wallet', 'bibisheng']
    },
    {
      'name': '管理',
      'modules': ['staff', 'level', 'assistant', 'employee']
    }
  ];

  constructor(e) {
    let keys = Object.keys(e);
    keys.forEach(key => {
      this[key] = e[key];
    });

    this.shangCengFlag = localStorage['shangCengFlag'];
    this.shangCengFlagSub = localStorage['shangCengFlagSub'];
    this.haveEmployee = localStorage['haveEmployee'];
    // console.log(this.shangCengFlag);
    // console.log(this.haveEmployee);

    /* 将要改为从服务器获取权限 */
    this.generateMenuPc();
    this.generateMenuWx();

    this.material_type = material_type;

    // let href = window.location.href;
    // if (href.indexOf('localhost') > -1 || href.indexOf('zidouzone') > -1) {
    //   this.material_type.push(
    //     {
    //       id: 'card',
    //       label: '公众号',
    //       real_type: 8,
    //       icon: 'solution',
    //       img: 'gongzhonghao'
    //     },
    //   );
    // }

    //有点儿瑕疵，先不用
    // this.copeHtml();
  }

  private generateMenuPc() {
    let temp: Array<MenuItem> = JSON.parse(JSON.stringify(classifyMenuPc));
    temp.forEach(item => {
      if (item.sub_items) {
        item.sub_items = item.sub_items.filter(value => {
          return this.menu_auth_pc.indexOf(value.id) > -1;
        });
      }
    });

    temp = temp.filter(item => {
      if (!item.sub_items) {
        return this.menu_auth_pc.indexOf(item.id) > -1;
      }
      else {
        return item.sub_items.length > 0;
      }
    });

    this.menu_pc = temp;

    //后端还没加模块的时候可以在这临时加
    let href = window.location.href;
    if (href.indexOf('localhost') > -1 || href.indexOf('zidouzone') > -1) {
      this.menu_pc.push(
        {
          id: 'group-manage',
          icon: 'calculator',
          title: '积分交易',
          router_link: '/features/score-deal',
          hide:true,
        },
      );
    }
  }

  private generateMenuWx() {
    if (!this.shangCengFlag) {
      let temp: Array<WxMenuItem> = JSON.parse(JSON.stringify(menuAllWx));
      temp = temp.filter(value => {
        return this.menu_auth_wx.indexOf(value.id) > -1;
      });

      this.menu_wx = temp;
    }
    else {
      this.menu_wx = [
        {
          id: 'sensitive',
          img: 'news.png',
          name: '群消息监控',
          status: '',
          is_old: true,
          page: 'SensitiveMsgPage'
        },
        {
          id: 'employee',
          img: 'saleman.png',
          name: '业务员监控',
          status: '',
          is_old: true,
          page: 'ScSupportMainPage'
        }
      ];
    }
  }

  /**
   * 更新 menu 数据*/
  public updateMenu() {
    this.generateMenuWx();
    this.generateMenuPc();
  }

  /**
   * 获取素材大类*/
  public getMaterialById(mId) {
    //noinspection TypeScriptUnresolvedFunction
    return this.material_type.find(value => {
      return value.id == mId;
    });
  }

  public setShangCengFlag(flag) {
    this.shangCengFlag = !!flag;
  }

  public setShangCengFlagSub(flag) {
    this.shangCengFlagSub = !!flag;
  }


  public getWxMenuById(id) {
    let _menu = this.menu_wx.filter(item => item.id == id);
    return _menu.length ? _menu[0] : null;
  }

  public getPcMenuById(id) {
    let _menu: Array<any>;
    for (let classifyMenu of this.menu_pc) {
      if (classifyMenu.id == id) {
        _menu = [classifyMenu];
        break;
      }
      else if (classifyMenu.sub_items) {
        _menu = classifyMenu.sub_items.filter(item => item.id == id);
        if (_menu.length) {
          break;
        }
      }
    }
    return _menu.length ? _menu[0] : null;
  }

  public fillMenu(menu) {
    let _menu = menu_list.filter(item => item.menu_id == menu.menu_id);
    return _menu.length ? _menu[0] : null;
  }
}

//测试环境的 eTest 在这里改，这样不必每一次 增加新功能 的时候都在 eTest 里再修改一次
//方法提升变量不提升啊！
const eTest = {
  app_name_real: 'test',
  base_url: 'https://api.zidouzone.com',
  base_url_c: 'https://api.zidouzone.com',
  // base_url_c: 'https://api2.zidouad.com',
  // base_url: 'https://192.168.100.164:8000',
  // base_url: 'https://192.168.100.2:8000',
  // base_url: 'https://127.0.0.1:8000',
  // base_url: 'https://192.168.1.45:8000',
  // base_url: 'https://192.168.100.181:8000',
  // base_url:'https://192.168.100.142:8000',
  // base_url:'https://www.easy-mock.com/mock/5c067782c7333b1980a5d608',
  domain: '',
  app_id: 'wxc8b40fcec9626528',
  token_name: 'testUserToken',
  host_url: 'https://wx.zidouzone.com',
  shareDirection:'shareDirection'
};

//最终产物
export let global = new Global(judgePlatform());

//重置global变量
export let resetGlobal = () => {
  global = new Global(judgePlatform());
  return global;
};

function judgePlatform() {
  let href = window.location.href;
  if (href.indexOf('localhost') > -1 || href.indexOf('192.168') > -1) {
    console.log(':::::::::::::::local');
    return Object.assign(eYaca, eTest);
    // return eTest;
    // return eYaca;
  } else if (href.indexOf('zidouzone') > -1) {
    console.log(':::::::::::::::test');
    return Object.assign(eYaca, eTest);
    // return eZidou;
  } else if (href.indexOf('zidouad') > -1) {
    console.log(':::::::::::::::yaca');
    return eYaca;
  } else if (href.indexOf('coin.zidouchat.com') > -1) {
    return eYaca
  } else if (href.indexOf('zidouchat') > -1) {
    console.log(':::::::::::::::zidouchat');
    return eZidou;
  } else {
    return eZidou;
  }
}



// WEBPACK FOOTER //
// ./src/environments/global.ts